import React, { useEffect, useState } from 'react';
;;
import { Button, Columns, Column, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal, Control, Field as BulmaField } from 'src/ui/mui-ui-kit';;
import { cleanseInput } from 'src/ui/util';

import { usePoseWithBulma } from 'src/ui/hooks';
import {
  FadeInDiv,
  AnimatedCard,
  UiInputAdapter,
  UiToggleAdapter,
  UiSelectAdapter,
} from 'src/ui';
import { composeValidators, number, email } from 'src/ui/validations';
import propTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { COMPLIANCE_TASK_FREQUENCY } from '../const';

export const AccountTaskModal = ({
  isActive,
  onSubmit,
  taskType,
  onCancel,
  data,
  formType,
}) => {
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );
  const [initialValues, setInitialValues] = useState(null);
  const [emailList, setEmailList] = useState([]);
  const [handleChange, setHandleChange] = useState(false);
  const { taskEmailList, accountName, taskId } = data;
  const handleSubmit = async (data, form) => {
    onSubmit(data, taskId);
    form.reset();
  };
  const buildInitialValues = () => {
    const newValues = {
      taskFrequency: COMPLIANCE_TASK_FREQUENCY.find(
        tsk => tsk.label === data.frequency
      ),
      isActive: data.isActive,
      tolerance:
        taskType === 'Gratuity'
          ? data.settings.tolerance?.toString() || '40'
          : null,
    };
    setInitialValues(newValues);
  };
  useEffect(() => {
    if (formType === 'Edit') {
      buildInitialValues();
    }
    if (taskEmailList) {
      setEmailList(taskEmailList.map(e => e.email));
    }
  }, [data]);

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={initialValues}
      handleChange={handleChange}
      setHandleChange={setHandleChange}
      subscription={{
        hasValidationErrors: false,
      }}
      mutators={{
        cleanse: ([event, cleansing], state, { changeValue }) => {
          cleanseInput(event, state, changeValue, cleansing);
        },
      }}
      render={({ form, hasValidationErrors, handleSubmit }) => {
        return (
          <form
            onSubmit={(e, form) => handleSubmit(e, form)}
            onChange={() => setHandleChange(true)}
          >
            <Modal isActive={isModalVisible} className="add-person-modal">
              <ModalBackground
                tag={FadeInDiv}
                pose={currentPose}
                onPoseComplete={onPoseComplete}
              />
              <ModalCard tag={AnimatedCard} pose={currentPose}>
                <ModalCardHeader>
                  <ModalCardTitle
                    tag="h5"
                    className="has-text-weight-semibold columns is-vcentered"
                  >
                    <Column tag="span" hasTextColor="primary" isPaddingless>
                      {`${formType} ${taskType} Check ${
                        formType === 'Edit' ? `for ${accountName}` : ''
                      } `}
                    </Column>
                  </ModalCardTitle>
                </ModalCardHeader>
                <ModalCardBody>
                  <Columns isMultiline>
                    <Column isSize="1/2">
                      <Field
                        component={UiToggleAdapter}
                        id={`isActive${taskType}`}
                        name="isActive"
                        type="checkbox"
                      >
                        {`Enable ${taskType} Check`}
                      </Field>
                    </Column>
                    <Column isSize="1/2">
                      {taskType !== 'Document' && (
                        <Field
                          component={UiSelectAdapter}
                          id={`taskFrequency${taskType}`}
                          type="dropdown"
                          name="taskFrequency"
                          label="Task Frequency"
                          options={COMPLIANCE_TASK_FREQUENCY}
                          getOptionLabel={item => item.label}
                          getOptionValue={item => item.value}
                          onFocus={() => setHandleChange(true)}
                        />
                      )}
                    </Column>

                    <Column isSize="1/2">
                      <Field
                        component={UiSelectAdapter}
                        name="addEmails"
                        id={`addEmails${taskType}`}
                        validate={composeValidators(
                          'Add Notification Email(s)',
                          email
                        )}
                        label="Add Notification Email(s)"
                        type="url"
                        isCreatable
                        components={{
                          DropdownIndicator: null,
                        }}
                        isMulti
                        placeholder="Type/paste and press enter..."
                        menuIsOpen={false}
                      />
                    </Column>
                    <Column isSize="1/2">
                      <Field
                        component={UiSelectAdapter}
                        name="deleteEmails"
                        id={`deleteEmails${taskType}`}
                        label="Delete Email(s)"
                        isMulti
                        options={
                          emailList?.map((email, idx) => ({
                            email,
                            idx,
                          })) || []
                        }
                        getOptionLabel={item => item.email}
                        getOptionValue={item => item.idx}
                        onFocus={() => setHandleChange(true)}
                      />
                    </Column>

                    <Column isSize="1/2">
                      {taskType === 'Gratuity' && (
                        <Field
                          component={UiInputAdapter}
                          id="tolerance"
                          name="tolerance"
                          label="Gratuity Tolerance %"
                          type="integer"
                          validate={composeValidators(
                            'Gratuity Tolerance %',
                            number({ min: 0, max: 100, required: false })
                          )}
                        />
                      )}
                    </Column>
                  </Columns>
                  <BulmaField isGrouped="centered">
                    <Control>
                      <Button
                        hasTextColor="info"
                        onClick={() => onCancel(form)}
                      >
                        Cancel
                      </Button>
                    </Control>
                    <Control>
                      <Button
                        isColor="gradient-bright"
                        type="submit"
                        disabled={!handleChange || hasValidationErrors}
                      >
                        Submit
                      </Button>
                    </Control>
                  </BulmaField>
                </ModalCardBody>
              </ModalCard>
            </Modal>
          </form>
        );
      }}
    />
  );
};

AccountTaskModal.propTypes = {
  isActive: propTypes.bool.isRequired,
  onSubmit: propTypes.func.isRequired,
  taskType: propTypes.string.isRequired,
  onCancel: propTypes.func.isRequired,
  data: propTypes.object.isRequired,
  formType: propTypes.string.isRequired,
};
